(function ($) {
    $(document).ready(function () {
        createGallerySlider();
        createPostSlider();
        createPostHeader();
        createAwardSlider();
    });

    function createPostHeader() {
        $(".post-header-slider").each(function () {
            let $wrap = $(this).closest(".post-header-slider");

            new Swiper(this, {
                loop: true,
                navigation: {
                    nextEl: $wrap.find(".swiper-button-next")[0],
                    prevEl: $wrap.find(".swiper-button-prev")[0],
                },
            });
        });
    }

    function createGallerySlider() {
        $(".loop-slider").each(function () {
            new Swiper(this, {
                loop: true,
                speed: 4000, // ms pro Slide-Schritt → Tempo (höher = langsamer)
                autoplay: {
                    delay: 0, // kein Stopp zwischen den Slides
                    disableOnInteraction: false,
                },
                spaceBetween: 30,
                slidesPerView: 1,
                breakpoints: {
                    576: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    992: { slidesPerView: 4 },
                    1200: { slidesPerView: 5 },
                    1400: { slidesPerView: 6 },
                },
            });
        });
    }

    function createPostSlider() {
        $(".post-slider").each(function () {
            let $wrap = $(this).closest(".tpl-loop");
            new Swiper(this, {
                loop: true,
                navigation: {
                    nextEl: $wrap.find(".swiper-button-next")[0],
                    prevEl: $wrap.find(".swiper-button-prev")[0],
                },
                a11y: {
                    prevSlideMessage: "Vorherige Beiträge",
                    nextSlideMessage: "Nächste Beiträge",
                },
                spaceBetween: 30,
                slidesPerView: 1,
                breakpoints: {
                    576: { slidesPerView: 2 },
                },
            });
        });
    }

    // Siegel-Slider (blocks/award-slider): Coverflow mit zurückhaltenden Werten – das
    // aktive Siegel vorn, die Nachbarn leicht gedreht und zurückgesetzt. Slides haben
    // eine feste Breite (CSS), daher slidesPerView "auto". Keine Klicks, keine Links.
    function createAwardSlider() {
        $(".award-slider__swiper").each(function () {
            var $wrap = $(this).closest(".award-slider");
            var slides = $(this).find(".swiper-slide").length;
            new Swiper(this, {
                effect: "coverflow",
                speed: 800, // Dauer eines Wechsels; Kurve + Opacity-Übergang in _template-parts.scss darauf abgestimmt
                coverflowEffect: {
                    rotate: 30, // Drehung der Nachbarn (Standard 50 wirkt zu plakativ)
                    stretch: 0,
                    // Wenig Tiefe + flache Skalierung: Die Nachbarn sind kleiner, kommen aber beim
                    // Wechsel nicht „aus der Tiefe geschossen" (hoher depth-Wert = starker Zoom).
                    depth: 100,
                    scale: 0.88,
                    modifier: 1,
                    slideShadows: false, // Siegel sind freigestellt → keine Schattenflächen
                },
                slidesPerView: "auto",
                centeredSlides: true,
                loop: slides > 2, // Loop braucht genügend Slides, sonst Lücken
                grabCursor: true,
                slideToClickedSlide: false,
                navigation: {
                    nextEl: $wrap.find(".swiper-button-next")[0],
                    prevEl: $wrap.find(".swiper-button-prev")[0],
                },
                a11y: {
                    prevSlideMessage: "Vorheriges Siegel",
                    nextSlideMessage: "Nächstes Siegel",
                },
            });
        });
    }
})(jQuery);
